<template>
  <div class="archery_container">
    <!-- <iframe id="archery" ref="archery" src="/archery.html"></iframe> -->
    활쏘기
  </div>
</template>